export const LuxPlusPartnerPromoClassifier = {
  TURO: 'TURO:lux_plus_au2',
  HELLOFRESH: 'HELLOFRESH:lux_plus_au2',
} as const

export type LuxPlusPartnerPromoClassifierType = typeof LuxPlusPartnerPromoClassifier[keyof typeof LuxPlusPartnerPromoClassifier]
